import { BottomSheet } from 'react-spring-bottom-sheet'
import styled from 'styled-components'

export const BottomSheetContainer = styled.div<{ height: number; isOpen: boolean }>`
    position: fixed;
    top: 0;
    right: 0;
    display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
    left: 0;
    overflow: hidden;
    height: ${({ height }) => height}px;
    z-index: 3;
`

export const BottomSheetContainerOverlay = styled.div<{ height: number; isOpen: boolean }>`
    position: fixed;
    top: 0;
    right: 0;
    display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
    left: 0;
    overflow: hidden;
    height: ${({ height }) => height}px;
    background-color: rgba(0, 0, 0, 0.75);
`

export const BottomSheetComponent = styled(BottomSheet)`
    &&& {
        * {
            font-family: 'Dasa Sans', 'Montserrat', sans-serif;
        }
        > div {
            height: auto !important;
            border-top-left-radius: 16px;
            border-top-right-radius: 16px;

            [data-rsbs-content] {
                height: 100% !important;
            }
        }
    }

    [data-rsbs-header]:before {
        width: 48px;
        height: 5px;
    }
`
